import { Sizes } from '../Models/Enums';

export function getSizes(sizes: Sizes): string {
  switch (sizes) {
    case Sizes.SMALL:
      return '12px';
    case Sizes.MIDDLE:
      return '16px';
    case Sizes.LARGE:
      return '20px';
  }
}

export function getAvatarSizes(sizes: Sizes): string {
  switch (sizes) {
    case Sizes.SMALL:
      return '44px';
    case Sizes.MIDDLE:
      return '52px';
    case Sizes.LARGE:
      return '64px';
  }
}
